import script from "./SqlEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SqlEditor.vue?vue&type=script&setup=true&lang=js"

import "./SqlEditor.vue?vue&type=style&index=0&id=1cb529d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb529d6"]])

export default __exports__